import { fieldPropertiesPanel } from '@wix/wix-data-client-common/dist/esm/panels/panelDefs'
import getPanelUrl from '@wix/wix-data-client-common/dist/esm/panels/getPanelUrl'

export default async ({
  editorSdkProxy,
  hostname,
  i18n,
  initialData: {
    name,
    keyIsRequired,
    key,
    typeOptions,
    type,
    otherKeys,
    origin,
    editorType,
  },
  y,
}) =>
  editorSdkProxy.editor.openToolPanel({
    url: await getPanelUrl({
      editorSdkProxy,
      hostname,
      relativeUrl: fieldPropertiesPanel.url,
    }),
    title: i18n.t('FieldPropertiesPanel_Title'),
    height: keyIsRequired ? 353 : 259,
    width: keyIsRequired ? 264 : 240,
    noPanelPadding: true,
    initialData: {
      name,
      keyIsRequired,
      key,
      typeOptions,
      type,
      otherKeys,
      origin,
      editorType,
    },
    x: 0,
    y,
  })
